import { render, staticRenderFns } from "./TermsHistory.vue?vue&type=template&id=30f32875&"
import script from "./TermsHistory.vue?vue&type=script&lang=ts&"
export * from "./TermsHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports